import { render, staticRenderFns } from "./courseOrder.vue?vue&type=template&id=037e8c90"
import script from "./courseOrder.vue?vue&type=script&lang=js"
export * from "./courseOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports